import React from 'react';

const HumidityIcon = ({
  color = '#FFFFFF'
}) => {
  return (
    <svg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 73.042c0 18.8 15.24 34.042 34.042 34.042 18.8 0 34.042-15.242 34.042-34.042 0-23.292-25.69-40.62-34.042-52.042C47.69 32.423 22 49.75 22 73.042zm70.857-28.624c0 .55.443.998 1.006.998h13.32c.557 0 1.007-.447 1.007-.998v-2.503c0-.55-.442-.998-1.006-.998h-13.32c-.556 0-1.007.447-1.007.998v2.503zm7.5 16.917c0 .55.443.998 1.006.998h13.32c.557 0 1.007-.447 1.007-.998v-2.503c0-.55-.442-.998-1.006-.998h-13.32c-.556 0-1.007.447-1.007.998v2.503zm2.166 17c0 .55.443 1 1.007 1h13.32c.557 0 1.007-.45 1.007-1v-2.503c0-.55-.442-.998-1.006-.998h-13.32c-.556 0-1.007.447-1.007.998v2.503zm-4.166 17c0 .55.443 1 1.006 1h13.32c.557 0 1.007-.45 1.007-1v-2.503c0-.55-.442-.998-1.006-.998h-13.32c-.556 0-1.007.447-1.007.998v2.503z'
        fill={color} fillRule='evenodd'
      />
    </svg>
  );
};

export default HumidityIcon;



// WEBPACK FOOTER //
// ./src/app/components/atoms/icons/HumidityIcon/HumidityIcon.js